




















































































import { Component, Vue } from 'vue-property-decorator';

// core
import InOutChanger from '@/components/system/InOutChanger.vue';
import WorkOrderListWidget from '@/components/home/worker/WorkOrderListWidget.vue';
import WorkerButtonsWidget from '@/components/home/worker/WorkerButtonsWidget.vue';
import WorkerCustomFilterButtonsWidget from '@/components/home/worker/WorkerCustomFilterButtonsWidget.vue';

// import { User } from 'oidc-client';
import { mapGetters } from 'vuex';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore -- this doesn't have typings so implicit 'any' will have to be ok.
import * as VueGridLayout from 'vue-grid-layout';

@Component({
  components: {
    InOutChanger,
    WorkOrderListWidget,
    WorkerButtonsWidget,
    WorkerCustomFilterButtonsWidget,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser'
  })
})
export default class HomeComponentGrid extends Vue {
  private layout: unknown[] = [];

  private defaultLayout = [
    {
      x: 0,
      y: 0,
      w: 6,
      h: 11,
      i: '0',
      c: 'WorkerButtonsWidget',
      isComponent: true
    },
    {
      x: 6,
      y: 0,
      w: 6,
      h: 11,
      i: '1',
      c: 'WorkerCustomFilterButtonsWidget',
      isComponent: true
    },
    {
      x: 0,
      y: 11,
      w: 12,
      h: 33,
      i: '2',
      c: 'WorkOrderListWidget',
      isComponent: true
    }
  ];

  private restoreDefaultLayout() {
    // reset layout to default and update local storage
    this.layout = JSON.parse(JSON.stringify(this.defaultLayout));
    window.localStorage.setItem('currentLayout', JSON.stringify(this.layout));
  }

  private layoutUpdatedEvent(newLayout: unknown[]) {
    // store layout config whenever it changes
    window.localStorage.setItem('currentLayout', JSON.stringify(newLayout));
  }

  private async created() {
    // get layout from local storage if it exists
    const currentLayoutLocalStorage =
      window.localStorage.getItem('currentLayout');

    if (currentLayoutLocalStorage) {
      var currentLayoutLocalStorageArray = JSON.parse(
        currentLayoutLocalStorage
      );
      if (this.defaultLayout.length === currentLayoutLocalStorageArray.length) {
        // set layout to stored layout config if available
        this.layout = currentLayoutLocalStorageArray;
      } else {
        // the count of grid items in the user's local storage does not match the intended amount of grid items
        // reset the grid layout to make sure the user has all available grid items in their layout
        this.layout = JSON.parse(JSON.stringify(this.defaultLayout));
      }
    } else {
      // set default layout when none stored
      this.layout = JSON.parse(JSON.stringify(this.defaultLayout));
    }
  }
}
